"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tz_date_fns_1 = require("tz-date-fns");
var util_1 = require("util");
exports.getNumberFormatWithComma = function (price) {
    if (!util_1.isNumber(price))
        return null;
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
exports.getNumberFormatWithCommaAndMax = function (number, max) {
    return util_1.isNumber(number) ? exports.getNumberFormatWithComma(Math.min(number, max)) + (number > max ? '+' : '') : 0;
};
// format 형식 - https://date-fns.org/v1.28.0/docs/format 참고
exports.getFormattedDate = function (date, foramt) {
    try {
        if (!date) {
            throw new Error("getFormattedDate !date");
        }
        var formattedDate = tz_date_fns_1.format(tz_date_fns_1.parse(date), foramt || DateFormat.YYYY_MM_DD, { locale: tz_date_fns_1.koLocale });
        if (formattedDate === 'Invalid Date') {
            throw new Error("getFormattedDate Invalid Date " + date);
        }
        return formattedDate;
    }
    catch (err) {
        return '';
    }
};
exports.getDayOfWeek = function (dateString) {
    var week = ['일', '월', '화', '수', '목', '금', '토'];
    return week[tz_date_fns_1.format(dateString, 'd', { locale: tz_date_fns_1.koLocale })];
};
exports.getDayAfterNDays = function (basisDate, day) {
    return tz_date_fns_1.addDays(basisDate, day);
};
exports.checkSameDay = function (day1, day2) {
    return tz_date_fns_1.isSameDay(day1, day2);
};
function eachDayOfWeek(date, numWeek) {
    if (numWeek === void 0) { numWeek = 1; }
    var startDate = tz_date_fns_1.startOfWeek(date);
    var endDate = numWeek > 1 ? tz_date_fns_1.endOfWeek(tz_date_fns_1.addWeeks(date, numWeek - 1)) : tz_date_fns_1.endOfWeek(date);
    return tz_date_fns_1.eachDay(startDate, endDate);
}
exports.eachDayOfWeek = eachDayOfWeek;
exports.convert24HhMmToAmPm = function (hhmm) {
    if (!hhmm || hhmm.length !== 4)
        return null;
    var date = new Date();
    var hours = parseInt(hhmm.substring(0, 2), 10);
    var minutes = parseInt(hhmm.substring(2), 10);
    date.setHours(hours);
    date.setMinutes(minutes);
    return exports.getFormattedDate(date, 'A h:mm');
};
var DateFormat;
(function (DateFormat) {
    DateFormat["YYYYMMDDHHmmss"] = "YYYYMMDDHHmmss";
    DateFormat["YYYY_MM_DD_HH_mm_ss"] = "YYYY-MM-DD HH:mm:ss";
    DateFormat["YYYY_MM_DD"] = "YYYY.MM.DD.";
    DateFormat["YYYY_MM_DD_dd_HH_mm"] = "YYYY.MM.DD.(dd) HH:mm";
    DateFormat["YYYY_MM_DD_dd"] = "YYYY.MM.DD.(dd)";
    DateFormat["YYYY_MM_DD_a_hh_mm"] = "YYYY.MM.DD. a hh:mm";
    DateFormat["YYYY_MM_DD_HH_mm"] = "YYYY-MM-DD HH:mm";
    DateFormat["YYYYMMDDhhmm"] = "YYYYMMDDhhmm";
    DateFormat["YYYY_MM"] = "YYYY.MM.";
    DateFormat["YYYYMMDD"] = "YYYYMMDD";
    DateFormat["YY_MM_DD"] = "YY.MM.DD.";
    DateFormat["M_D_dd"] = "M/D(dd)";
    DateFormat["A_h"] = "A h";
    DateFormat["DD"] = "DD";
    DateFormat["MM_DD"] = "MM.DD";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
//# sourceMappingURL=format.js.map